import { Reveal } from "@/components/site/shared";

const DAYS = [
  {
    day: "Friday",
    date: "May 21",
    bg: "bg-blueglass",
    events: [
      { time: "6:00 PM", title: "Welcome Drinks", where: "The Tin Ceiling Bar · casual" },
      { time: "8:30 PM", title: "Late Night Snacks", where: "Cookie table + dips" },
    ],
  },
  {
    day: "Saturday",
    date: "May 22",
    bg: "bg-cottoncandy",
    events: [
      { time: "4:30 PM", title: "The Ceremony", where: "Under the arch · be seated by 4:15" },
      { time: "5:30 PM", title: "Cocktail Hour", where: "Solo cups encouraged" },
      { time: "7:00 PM", title: "Dinner & Toasts", where: "Family style" },
      { time: "9:00 PM", title: "Dance Floor Opens", where: "Disco balls on, lights low" },
    ],
  },
  {
    day: "Sunday",
    date: "May 23",
    bg: "bg-butter",
    events: [
      { time: "10:30 AM", title: "Farewell Brunch", where: "Come as you are" },
    ],
  },
];

export default function Schedule() {
  return (
    <div>
      <section className="pt-32 md:pt-40 pb-12 max-w-7xl mx-auto px-6 md:px-8">
        <Reveal>
          <p className="overline text-orange">Order of the Day</p>
          <h1 className="font-display text-5xl sm:text-6xl md:text-8xl text-ink mt-4 leading-[0.95]">
            The whole <br />weekend
          </h1>
          <p className="font-body text-lg text-ink/80 mt-6 max-w-xl">
            Three days, one big celebration. Here's everything you need to know to be in the right place at the
            right time.
          </p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-8 pb-24 md:pb-32 space-y-6">
        {DAYS.map((d, di) => (
          <Reveal key={d.day} delay={di * 0.08}>
            <div className="grid md:grid-cols-12 gap-5 items-start">
              <div className={`md:col-span-3 card-retro ${d.bg} p-6 md:sticky md:top-24`}>
                <p className="overline text-ink/70">{d.date}</p>
                <p className="font-display text-4xl md:text-5xl text-ink mt-2">{d.day}</p>
              </div>
              <div className="md:col-span-9 grid sm:grid-cols-2 gap-5">
                {d.events.map((e) => (
                  <div
                    key={e.title}
                    className="card-retro bg-cream p-6 transition-transform duration-200 hover:-rotate-1"
                    data-testid={`event-${e.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  >
                    <p className="font-grotesk font-bold text-orange text-lg">{e.time}</p>
                    <p className="font-grotesk font-extrabold text-2xl text-ink mt-1 tracking-tight">{e.title}</p>
                    <p className="font-body text-ink/70 mt-2">{e.where}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
